import { useParams } from 'react-router-dom';

/**
 * Returns a `lp()` helper that prefixes a path with the current `/:lang`
 * segment so internal navigation stays inside the same language.
 *
 *   const lp = useLp();
 *   <Link to={lp('/dashboard')} />     // → /en/dashboard
 *   <Link to={lp('/#pricing')} />      // → /en#pricing  (root-hash links)
 *   <Link to={lp('budi-dan-sari')} />  // → /en/budi-dan-sari
 *
 * External URLs (http*), pure hash fragments (#foo), and tel:/mailto: are
 * returned untouched.
 */
export function useLp() {
  const { lang: paramLang } = useParams();
  const lang = paramLang === 'id' || paramLang === 'en' ? paramLang : 'en';
  const prefix = `/${lang}`;

  return (path) => {
    if (!path) return prefix;
    if (typeof path !== 'string') return path;
    if (/^(https?:|mailto:|tel:)/i.test(path)) return path;
    if (path.startsWith('#')) return prefix + path;          // bare hash → /en#x
    if (path.startsWith('/#')) return prefix + path.slice(1); // /#x → /en#x
    if (path.startsWith('/')) return prefix + path;
    return `${prefix}/${path}`;
  };
}

/** Current `:lang` URL param, normalized to 'id' or 'en'. */
export function useLang() {
  const { lang } = useParams();
  return lang === 'id' || lang === 'en' ? lang : 'en';
}
